import _ from "lodash";
import { currencyValueFormatter } from "helpers/product-collection";

import type { IDetailHeaderPrices, IGridEntry, IOrderCurrency, ISizeHeaderPrices } from "types/cart/shipment-review";

export const getPricingMap = (entries: IGridEntry[], currency: IOrderCurrency): IDetailHeaderPrices =>
    _.mapValues(_.groupBy(entries, "size.size"), (entries) => {
        const originalPrices = _.map(entries, "pricing.original_wholesale");
        const currentPrices = _.map(entries, "pricing.wholesale");
        const originalPricesRange = [_.minBy(originalPrices), _.maxBy(originalPrices)];
        const currentPricesRange = [_.minBy(currentPrices), _.maxBy(currentPrices)];
        return {
            prices: _.uniq(
                _.map(currentPricesRange, (price) =>
                    currencyValueFormatter(currency.wholesale.symbol, currency.wholesale.decimalPlaces, price),
                ),
            ),
            discount: !_.isEqual(currentPricesRange, originalPricesRange),
        };
    });

export const getDbpPrices = (entries: IGridEntry[], currency: IOrderCurrency): ISizeHeaderPrices => {
    const originalPrices = _.map(entries, "pricing.original_wholesale");
    const currentPrices = _.map(entries, "pricing.wholesale");
    const originalPricesRange = [_.minBy(originalPrices), _.maxBy(originalPrices)];
    const currentPricesRange = [_.minBy(currentPrices), _.maxBy(currentPrices)];
    return {
        prices: _.uniq(
            _.map(currentPricesRange, (price) =>
                currencyValueFormatter(currency.wholesale.symbol, currency.wholesale.decimalPlaces, price),
            ),
        ),
        discount: !_.isEqual(currentPricesRange, originalPricesRange),
    };
};
